import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Business Process Automation (BPA)?",
    answer: `<p>Business Process Automation is when you make use of technology to streamline the workflows and automate the repetitive tasks to improve accuracy, efficiency, and scalability across your operations.</p>`,
  },
  {
    question: "Will TekRevol's solutions integrate into my existing systems?",
    answer: `<p>Yes. At TekRevol, we design BPA solutions to be easily integrated into your existing infrastructure, ERP, CRM, and cloud environments.</p>`,
  },
  {
    question: "How long does it take to implement a BPA solution?",
    answer: ` <p>Implementation timelines are relatively complex when it comes to implementing a BPA solution. Usually, it takes a few weeks for targeted workflows or several months for enterprise-wide deployments.</p>`,
  },
  {
    question: "What support do you provide after deployment?",
    answer: `<p>We provide continued monitoring, optimization, and technical support to ensure the automated systems are functioning at optimal efficiency.</p>`,
  },
  {
    question: "What is the difference between RPA and Intelligent Automation?",
    answer: `<p>RPA emulates human-led actions in rule-based activities, while Intelligent Automation pairs RPA with AI/ML to automate more complex decision-based activities.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg"
      style={{ background: "#05151E" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Business Process Automation FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
